import type { EnrichedFixture } from "../../shared/types";

// The free football-data.org tier can lag well past kickoff before flipping a
// match to IN_PLAY. From kickoff until the match could plausibly have
// finished, treat a still-"scheduled" fixture as kicked off so the UI doesn't
// present it as upcoming.
const AWAITING_WINDOW_MS = 3 * 60 * 60 * 1000;

export function isKickedOffAwaitingData(
  fixture: EnrichedFixture,
  now: number = Date.now()
): boolean {
  if (fixture.status !== "scheduled" || fixture.isPlaceholder) return false;
  const kickoff = new Date(fixture.dateUtc).getTime();
  return now >= kickoff && now - kickoff <= AWAITING_WINDOW_MS;
}
